<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  @if (!data.rows?.length) {
    <p class="text-muted mb-0">No tax breakdown data available.</p>
  }
  @if (data.rows?.length) {
    <table class="table table-sm table-bordered mb-0">
      <thead>
        <tr>
          <th style="text-align: left; padding: 8px;">Tax Name</th>
          <th style="text-align: right; padding: 8px;">Tax Amount</th>
        </tr>
      </thead>
      <tbody>
        @for (tax of data.rows; track $index) {
          <tr>
            <td style="padding: 8px;">{{ tax.name || '-' }}</td>
            <td style="padding: 8px; text-align: right;">
              {{ tax.amount | statementAmount }}
            </td>
          </tr>
        }
      </tbody>
      <tfoot>
        <tr style="background-color: #f8f9fa; font-weight: 600;">
          <td style="padding: 8px; text-align: right;">Total:</td>
          <td style="padding: 8px; text-align: right;">
            {{ total | statementAmount }}
          </td>
        </tr>
      </tfoot>
    </table>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button type="button" mat-dialog-close class="btn btn-secondary btn-sm">Close</button>
</mat-dialog-actions>
